module.exports = __webpack_public_path__ + "img/12 boton saltar pregunta.bd971ce9.svg";